import { useContext } from 'react';
import { AdminOutcomesContext } from '../AdminOutcomesContext';

export const useAdminOutcomesContext = () => {
    const adminOutcomesContext = useContext(AdminOutcomesContext);

    if (!adminOutcomesContext) {
        throw new Error('AssessmentContext not initialized');
    }

    return adminOutcomesContext;
};
